import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-color-block-header',
  templateUrl: './bmcore-color-block-header.component.html',
  styleUrls: ['./bmcore-color-block-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreColorBlockHeaderComponent implements OnInit {
  @Input() groupTitle: string
  @Input() currentGroupTitle: string

  lg: LgType

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }
}
